module.exports = __webpack_public_path__ + "img/3D.2588e5b1.png";